<template>
  <div>
    <h1 class="title has-text-centered">Introduction Test</h1>
    <span>
      <!-- For Rules Description -->
      <div class="columns is-12">
        <div class="column is-2">
          <b>Introduction</b>
          <b-tooltip type="is-danger" label="This field is required">
            <span class="required">*</span>
          </b-tooltip>
        </div>
        <div class="column is-10">
          <ValidationProvider
            :vid="`descriptionIntroductionTest`"
            name="subsection"
            :rules="`required`"
            v-slot="{ errors }"
          >
            <ckeditor v-model="data.description" :config="editorConfig" />
            <span class="required">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => {}
    }
  },
  data() {
    return {
      editorConfig: {
        // The configuration of the editor.
        extraAllowedContent: "div[class]",
        allowedContent: true,
        // filebrowserUploadMethod: "form",
        // filebrowserUploadUrl: process.env.VUE_APP_BACKEND_URL + "/api/ckeditor/upload-image",
        extraPlugins: "justify,font"
      }
    };
  }
};
</script>
